import MapMarker from "@/components/MapMarker/MapMarker";
import {Link} from "@/i18n/routing";
import React from "react";
import {usePlaceMarker} from "@/utils/hooks/usePlaceIcon";
import {Place} from "@/types/Places";
import {Stack} from "@mui/material";

export default function PlaceMarker(props: { segment_id: number, item: Place }) {
  const {item, segment_id} = props
  const Icon = usePlaceMarker(item, String(segment_id))
  if (!Icon) {
    return <MapMarker title={item.name} latitude={Number(item.latitude)}
                      longitude={Number(item.longitude)}
                      background={'#E91293'} border={'#35B6EF'} glyph={'#35B6EF'}>
      <Stack direction={"column"} spacing={1} sx={{alignItems: 'center', width: '100%'}}>
        <Link href={`/place/${item.id}`}>Informazioni</Link>
      </Stack>
    </MapMarker>
  } else {
    return <MapMarker icon={Icon} title={item.name} latitude={Number(item.latitude)}
                      longitude={Number(item.longitude)}
                      background={'#E91293'} border={'#35B6EF'} glyph={'#35B6EF'}>
      <Stack direction={"column"} spacing={1} sx={{alignItems: 'center', width: '100%'}}>
        <Link href={`/place/${item.id}`}>Informazioni</Link>
      </Stack>
    </MapMarker>
  }

}
